function ControllerSliderConHover() {
    let advanceSlider = 10;
    let idIntervalAnimation;
    let idContentSliderActive;
    function init() {
        listennerItems();
        listennerButtons();
    }
    function listennerItems() {
        const classActive = 'block-u-slider-con-hover__item--active';
        const classItem = '.block-u-slider-con-hover__item';
        let idTimeOut = 0;

        if (jQuery(window).width() >= 1024) {
            jQuery(classItem).on('mouseover', function () {
                
                const jElement = jQuery(this);
                jQuery(classItem).removeClass(classActive);
                const time = jElement.data('time');
                if (time) {
                    clearTimeout(time);
                }
                jElement.addClass(classActive);
                var elementPhrase = jQuery(this).find(".block-u-slider-con-hover__item__info__frase");
                idTimeOut = setTimeout(() => {
                    elementPhrase.css({
                        opacity: 1
                    });
                }, 220);
            });
            jQuery(classItem).on('mouseout', function () {
                
                const jElement = jQuery(this);
                var elementPhrase = jQuery(this).find(".block-u-slider-con-hover__item__info__frase");
                jQuery(".block-u-slider-con-hover__item__info__frase").removeClass("block-u-slider-con-hover__item__info__frase--active");
                if (idTimeOut) {
                    clearTimeout(idTimeOut);
                }
                const id = setTimeout(() => {
                    elementPhrase.css({
                        opacity: 0
                    });
                }, 10);
                jElement.data('time', id);

            });
        }
    }
    function moveSliderContentLeft() {
        stopSlider();
        advanceSlider = -10;
        const elemnt = jQuery(this);
        const idContent = elemnt.data('content');
        idContentSliderActive = idContent;

        idIntervalAnimation = setInterval(animationScroll, 20);
    }
    function moveSliderContentRight() {
        stopSlider();
        advanceSlider = 10;
        const elemnt = jQuery(this);
        const idContent = elemnt.data('content');
        idContentSliderActive = idContent;

        idIntervalAnimation = setInterval(animationScroll, 20);
    }
    function stopSlider() {
        advanceSlider = 0;
        if (idIntervalAnimation) {
            clearInterval(idIntervalAnimation);
        }

    }
    function animationScroll() {
        const elemtnJquery = jQuery(`#${idContentSliderActive}`);
        const currentScrollLeft = elemtnJquery.scrollLeft();
        const left = currentScrollLeft + advanceSlider;
        elemtnJquery.scrollLeft(left);
    }
    function listennerButtons() {
        jQuery('.block-u-slider-con-hover__slider__button--left').on('mouseover', moveSliderContentLeft);
        jQuery('.block-u-slider-con-hover__slider__button--right').on('mouseover', moveSliderContentRight);
        jQuery('.block-u-slider-con-hover__slider__button--left').on('mouseout', stopSlider);
        jQuery('.block-u-slider-con-hover__slider__button--right').on('mouseout', stopSlider);
    }
    init();
}
new ControllerSliderConHover();